<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <!--<div v-for="(data,name) in filter">-->
    <!--<v-card class="pa-2 primary" outlined tile-->
    <!--v-for="value in data.current">-->
    <!--<v-icon class="float-right" @click="setFilter(name,value.key)">mdi-close</v-icon>-->
    <!--{{value.text}}-->
    <!--</v-card>-->
    <!--</div>-->

    <div class="option_filter">
      <div v-for="(data,name) in filter">
        <!--<div >{{data.label}} </div>-->
        <div class="option_container">
          <v-btn tile class="btn_filter"
                 :class="{'primary':data.current.length==0}"
                 @click="clearFilter(name)">
            ทั้งหมด({{ getTotalCount(data.options) }})
          </v-btn>
          <v-btn tile class="btn_filter"
                 :class="{'active':option.active}"
                 v-for="option in data.options"
                 :color="option.active?getStatusColor(option.key):'gray'"
                 :title="getStatusAlt(option.key)"
                 @click="setFilter(name,option.key,option.text)">
            {{ option.text }}({{ option.count }})
          </v-btn>
        </div>
      </div>
    </div>
  </div>

</template>
<style lang="scss" scoped>
.option_filter {
  margin: 0 1px;
  padding: 0 2px 0 0;

  .v-expansion-panel-header {
    /*padding: 16px 24px;*/
    padding: 4px 8px;
  }

  .v-expansion-panel-content {
    /*padding: 0 8px 4px;*/
    /*padding: 0 24px 16px;*/
    padding: 0;

  }

  .v-list-item {
    /*padding: 0 16px;*/
    padding: 0 4px;
  }
}

.btn_filter.active {
  /*border: solid 2px red;*/
}

.option_container {
  padding: 0 4px 0 0;
}

.btn_filter {
  min-width: 20px !important;
  padding: 0 4px !important;
  margin-left: 4px;

}
</style>

<script lang="ts">

import {FilterCustomer} from '@/models/Customer'
import {Component, Prop, Vue} from 'vue-property-decorator'
import {FilterOrder, OrderConst} from '../models/Order'


@Component({
  components: {}
})
export default class FilterCurrent extends Vue {
  @Prop() filter: FilterOrder | FilterCustomer
  @Prop() setFilter: (name: string, key: string, text: string) => void
  @Prop() clearFilter: (name: string) => void
  @Prop() OptionGetStatusColor: (number: number|string) => string


  getTotalCount(options) {
    if (options.length == 1) {
      return options[0].count
    } else if (options.length > 0)
      return options.reduce((accumulator, option) => {
        // console.log('accumulator', accumulator)
        if (typeof accumulator == 'object') {
          accumulator = accumulator.count
        }
        return accumulator + parseInt(option.count)
      })
    return 0
  }

  getStatusColor(status:number|string) {
    if(this.OptionGetStatusColor){
      return this.OptionGetStatusColor(status)
    }
    return OrderConst.color(status)
  }

  getStatusAlt(status) {
    return OrderConst.alt(status)
  }
}

</script>
